export enum FilterDataType {
  String = 1,
  Number = 2,
  List = 3
}
